<template>
  <div class="EndOfPartsTableComponent DataTables">
    
    <div v-show="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>
      <!-- <b-form-select id="years_select"  v-if="isData" v-model="selectedDays" :options="optionsDays" size="sm" class="mt-1 select-time"></b-form-select> -->

    </div>
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from '../../Tools/Tools'

export default {
  name: 'EndOfPartsTableComponent',
  props:{
    lang: Object,
    
  },
  components: {
    LoaderComponent

  },
  data () {
      return {
        mainTable: "",
        id: "EndOfPartsTableComponent" + this._uid,
        columns: [],
        colsAssign: [],
        parts: [],
        isData: false,
        optionsDays: [
          { value: 365, text: this.lang.label_Year },
          { value: 180, text: this.lang.label_6Months },
          { value: 90, text: this.lang.label_3Months },
          { value: 30, text: this.lang.label_1Month },
          
        ],
        selectedDays: 365

      }
  },
  computed: {
    
   

  },
  created () {

    this.createTable();

  },
  watch: {
      selectedDays: function () {
        

        this.createTable();
      }
    
  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    createTable(){
      let vue = this;

       const obj = {
           days: this.selectedDays
       }
        

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getEndOfParts", obj)
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          this.parts = result.data;
          vue.isData = true;  
          


          vue.buildColumns();


        }else{
            vue.isData = false;  
        }


      })
    },
    buildColumns(){

      this.columns = [
        {
          name: "ProjectId",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "PartId",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_ProjectName,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_PartNumber,
          alignInColumn: "left",
          type: "text"
        },
        // {
        //   name: this.lang.table_header_Revision,
        //   alignInColumn: "left",
        //   type: "taxt"
        // },
        {
          name: this.lang.table_header_EndOfLife,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_EndOfSale,
          alignInColumn: "left",
          type: "text"
        },
        
      ]

      this.colsAssign =  [
        { "data": "revisionPartId" },
        { "data": "projectId" },
        { "data": "projectName" },
        { "data": "partNumber" },
       // { "data": "partRevision" },
        { "data": "endOfLife"},
        { "data": "endOfSale"},
        
               
      ]

      this.buildTable();
    },
    buildTable(){
      


      var tableplace = document.getElementById(this.id);
      if (tableplace == null) {
        return;
      }

      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var table = document.createElement("table");
      table.setAttribute("id", "t_" + this.id);
      table.setAttribute("style", "width:100%");
      table.setAttribute("class", "table table-striped table-bordered");
      tableplace.appendChild(table)

      var tr = document.createElement("tr");
      tr.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr);
      table.appendChild(thead);

      var _vue = this;


      let columnDefs = [];
      var len = this.columns.length;
      for (var i = 0; i < len; i++){

        var el = {};

        var classname = '_dt-body-'+ this.columns[i].alignInColumn;

        el = {
          targets: i,
          className: classname,

          render: function ( data, type, row, meta ) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            if (meta.col == 2) {
              let str = data;
              if (data.length > 25) {
                let substr = data.substr(0, 25);
                str = substr.trim() + "...";
              }
              return str;
            }
            
            
            if (meta.col == 4){
                let status = "";
                if (data != ""){
                    status = "<b-badge class='badge badge-warning '>" + Tools.longDateToShort(data, false) + "</b-badge>";
                }
                
                return status;
            }
            if (meta.col == 5){
              let status = "";
                
                if (data != ""){
                    status = "<b-badge class='badge badge-info '>" + Tools.longDateToShort(data, false) + "</b-badge>";
                }
                
                return status;
            }
            

            return data;
          }


        }

        columnDefs.push(el);


        var th = document.createElement("th");
        tr.appendChild(th);
        var br = document.createElement("br");
        th.appendChild(br);

        var tx = document.createTextNode(this.columns[i].name)
        th.appendChild(tx);

      }


      var option = {};
      option.paging = true;
      option.info = true;
      option.dom = '<fBr<t>ip>';
      option.data= this.parts;
      option.myColumnFormats = this.columns;
      option.select = true;
      option.order = [[3, "asc"]];
      option.lengthMenu = [[6]];
      option.columns = this.colsAssign;

      option.columnDefs = columnDefs;
      option.initComplete = function () {


        

      }

      option.buttons = [
        {
          extend: 'collection',
          text: 'Time interval',
          buttons: [
            {
              text: 'Year',
              action: function (e, dt, node, config) {
                
                _vue.selectedDays = 365;
              }
            },
            {
              text: '6 month',
              action: function (e, dt, node, config) {

                _vue.selectedDays = 180;
              }
            },
            {
              text: '3 month',
              action: function (e, dt, node, config) {

                _vue.selectedDays = 90;
              }
            },
            {
              text: '1 month',
              action: function (e, dt, node, config) {

                _vue.selectedDays = 30;
              }
            }
          ]
        }
      ]




      if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
          this.mainTable.destroy();
          
      }

      var _vue = this;

      this.mainTable = $('#t_'+this.id).DataTable(option);

      this.mainTable.columns.adjust().draw();

      //hide first column in table
      this.mainTable.column( 0 ).visible( false );
      this.mainTable.column( 1 ).visible( false );

      let _mainTable = this.mainTable;

      // let years_list_place = document.getElementById("years-list");
      // console.log(years_list_place)
      // let years_select = document.getElementById("years_select")
      // if (years_list_place != null && years_select != null) {
      //   years_list_place.appendChild(years_select)
      // }

      this.mainTable
        .on( 'select', function ( e, dt, type, indexes ) {

          var rowData = _mainTable.rows( indexes ).data();
          //console.log("select")
          //console.log(rowData[0])

          

        })
        .on( 'deselect', function ( e, dt, type, indexes ) {
          //console.log("deselect")
          
        })
        //$("#t_"+this.id +" tr").dblclick(function (evt) {
        $("#t_"+this.id +" tbody").on('dblclick', 'tr', function () {

               
          let rowData = _mainTable.rows( this._DT_RowIndex ).data();

          _vue.goTo(rowData[0]);
                
        });

      //search input change view
      var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }
      searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm")


    },
    goTo(goalObj){



      // let theHighestRev = {
      //   revisionId: goalObj.revisionId,
      //   revision: goalObj.revision,
      //   checked: true
      // };

      // this.$store.dispatch("selectRevisionRow", theHighestRev)

      this.$store.dispatch("deleteAllSelectedRows");

      let obj = {
        col___revisionId: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          
          value: {
            display: goalObj.projectRevisionId
          }
        },
        col___revision: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          value: {
            display: ""
          }
        },
        col___status: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          value: {
            display: ""
          }

        },
        col___name: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          value: {
            display: goalObj.projectName
          }

        },
        col___image: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          value: {
            display: ""
          }
        },
        col___projectType: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          value: {
            display: ""
          }
        }
      }
    
      this.$store.dispatch("setSelectedRows", [obj]);
      
      this.$store.dispatch("setOuterData", true);

      let to = "/ProjectManager/ProjectDetails";

      

      const query = {
        from: this.$route.path,
        to: to,
        revisionId: goalObj.projectRevisionId,
        id: goalObj.projectId

      }

      this.$router.push({ path: to, query: query });

      
    }

  }
}
</script>


<style lang="scss">
  .EndOfPartsTableComponent{
    width: 100%;
    .DataTables {
        padding-bottom: 2px;
    }

    .dataTables_info{
        max-width: 49%;
        float: left;
    }
    .dataTables_paginate {
        max-width: 49%;
        float: right;
    }

    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      margin-bottom: 0px;
    }
    table th {
      padding: 2px !important;

    }
    table p{
      margin-bottom: 0px;
    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      white-space: nowrap;
    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
    .select-time{
      height: 26px;
      padding-top: 0.15rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/EndOfPartsTableComponent.vue